/*
 * @Author: pengyong
 * @Date: 2020-11-09 15:47:00
 * @LastEditors: awu
 * @LastEditTime: 2020-12-08 21:53:32
 * @Description: element-ui按需加载
 * @FilePath: /exhibit/src/plugin/element.js
 */
import Vue from "vue";
import { Option, Select, Collapse, CollapseItem, Pagination, Message, Loading, Button , Image } from "element-ui";
import { i18n } from "../lang";
import ElementLocale from "element-ui/lib/locale";

Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Pagination);
Vue.use(Image);
// Vue.use(Popover);
Vue.use(Loading.directive);

Vue.prototype.$message = Message;

ElementLocale.i18n((key, value) => i18n.t(key, value));



// WEBPACK FOOTER //
// ./src/plugin/element.js